import { Component, Input } from "@angular/core";
import { FormGroup, AbstractControl } from "@angular/forms";

@Component({
    selector: "ig-validator",
    templateUrl: "./validator.component.html",
    styleUrls: ["./validator.component.scss"]
})
export class ValidatorComponent {

    /**
     * Reference to the form
     *
     * Rather than just passing the control right away, we may also want to use
     * a reference to the form itself in some case.
     */
    @Input()
    form: FormGroup;

    /**
     * Name of the control
     */
    @Input()
    ctrl: string;

    /**
     * Submitted state of the form
     */
    @Input()
    submitted: boolean;

    /**
     * Checks if the control has an actual value
     */
    notEmpty(ctrl: AbstractControl) {
        const value = ctrl.value;

        return value != null
            && value !== "";
    }

    get formControl(): AbstractControl {
        return this.form.controls[this.ctrl];
    }

    /**
     * Returns true if the control is neither valid nor invalid
     * @todo: Should also be shown if the form is actually submitted
     */
    get isNeutral(): boolean {
        if (this.submitted) {
            return !!this.formControl.valid;
        }
        return !this.submitted;
    }

    /**
     * Returns true of the control is valid
     *
     * Handles optional controls as well
     */
    get isValid(): boolean {
        return this.formControl.valid
            && this.notEmpty(this.formControl);
    }

    /**
     * Returns false if the control is invalid
     */
    get isInvalid(): boolean {
        return this.submitted
            && this.formControl.invalid;
    }
}
